export default function IconRefresh({ height, width, fill, blur }) {
  //const { height, width } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="icon"
      width={width ? width : height ? height : 20}
      height={height ? height : width ? width : 20}
      viewBox="0 0 42 42"
    >
      <defs>
        <filter
          id="Shape"
          x="0"
          y="0"
          width="50.298"
          height="50.298"
          filterUnits="userSpaceOnUse"
        >
          <feOffset input="SourceAlpha" />
          <feGaussianBlur stdDeviation="5" result="blur" />
          <feFlood floodColor={blur && "#00fe78"} />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Shape)">
        <path
          d="M23.9 40.7q-6.9 0-11.8-4.875T7.2 24q0-6.9 4.9-11.825Q17 7.25 23.9 7.25q4.45 0 7.8 1.8 3.35 1.8 5.8 4.95V8.95q0-.75.45-1.225.45-.475 1.2-.475.7 0 1.175.475.475.475.475 1.225v10.1q0 .85-.575 1.4-.575.55-1.425.55H28.7q-.7 0-1.175-.45-.475-.45-.475-1.2 0-.7.475-1.175Q28 17.7 28.75 17.7h6.6q-1.95-2.9-4.775-4.675T23.9 11.25q-5.35 0-9.05 3.7-3.7 3.7-3.7 9.05 0 5.35 3.7 9.05 3.7 3.7 9.05 3.7 3.7 0 6.85-1.975Q33.9 32.8 35.5 29.5q.3-.45.85-.8.55-.35 1.1-.35 1.2 0 1.725.775.525.775.025 1.775-2 4.45-6.125 7.125T23.9 40.7Z"
          fill={fill ? fill : "#6C7270"}
        />
      </g>
    </svg>
  );
}
